<template>
    <div class="tabs-container" :style="{'width' : (noWidthSet ? 'unset' : '')}">
        <div class="tabs-menu">
            <nav class="tab-label">
                <div v-for="(tab, index) in tabs" :key="index" class="tab" :class="[(index == 0) ? 'first' : ((index == tabs.length - 1) ? 'last' : 'middle')]" @click="switchTab(tab.id)" ref="tabs">
                    <span :class="{ 'active': activeTab === tab.id, 'custom-tab': true }">
                        {{ tab.label }}
                    </span>
                </div>
            </nav>
            <div class="indicator-container">
                <div class="active-tab-indicator" :style="indicatorStyles"></div>
            </div>
        </div>
    </div>
    <div :class="className">
      <slot></slot>
    </div>
</template>
  
<script>
import tools from '@/assets/js/tools.js';
    export default {
        props: {
            tabs: Array, // Массив объектов вида { id: 'faq', label: 'Наше предложение' }
            className: {
                type: String,
                default: 'tab-content'
            },
            noWidthSet: Boolean,
        },
        data() {
            return {
                activeTab: null,
                tools: tools,
            };
        },
        mounted() {
            this.initializeActiveTab();
        },
        computed: {
            indicatorStyles() {
                if (this.activeTab !== null) {
                    const activeTabIndex = this.tabs.findIndex((tab) => tab.id === this.activeTab);
                    const tabWidth = this.$refs.tabs[activeTabIndex].offsetWidth;
                    const tabLeft = this.$refs.tabs[activeTabIndex].offsetLeft;

                    return {
                        width: `${tabWidth}px`,
                        transform: `translateX(${tabLeft}px)`,
                    };
                }

                return {
                    width: '0px',
                    transform: 'translateX(0)',
                };
            },
        },
        methods: {
            switchTab(tabId) {
                if (this.activeTab === tabId) return;

                this.$emit('tab-active', tabId);
                this.activeTab = tabId;
            },
            initializeActiveTab() {
                if (this.tabs.length > 0) {
                    this.activeTab = this.tabs[0].id;
                }
            },
        },
    };
</script>
  
<style scoped>
.tabs-container {
    display: flex;
    position: relative;
    /* justify-content: baseline; */
    flex-flow: column;
    padding-bottom: 32px;
}

.about_tabs {
    display: flex;
    flex-flow:column;
    justify-content: center;
    align-items: center;
}

.tab-label {
    display: flex;
    width: 100%;
}

/* @media (max-width: 1024px) { */
    .tabs-container {
        width: 92vw;
        margin-left: auto;
        margin-right: auto;
    }
    .tab {
        font-size: calc(14px + 6 * ((100vw - 320px) / 680));
        white-space: nowrap;
        padding-bottom: 10px;
        flex-grow: 1;
    }
    .tabs-menu {
        width: 100%;
    }
    .tab-content {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }
/* } */

@media (min-width: 1200px) {
    .tabs-container {
        width: 71vw;
        margin-left: 0px;
        margin-right: 0px;
    }
    .tab {
        font-size: calc(8.5px + 6 * ((100vw - 320px) / 680));
        white-space: nowrap;
        padding-bottom: 10px;
        flex-grow: 1;
    }
    .tabs-menu {
        width: fit-content;
    }

    .tab-content {
        width: 100%;
        margin: 0;
    }
}

.tab.first {
    text-align: left;
}
.tab:not(.first) {
    margin-left: 50px;
}
.tab.middle {
    text-align: center;
}
.tab.last {
    text-align: right;
}

.custom-tab {
    cursor: pointer;
    color: #6E7675;
    text-decoration: none;
    transition: color 0.3s ease;
}

.indicator-container {
    position: relative;
    height: 5px;
    background: #e9ecec;
}
  
.active-tab-indicator {
    position: absolute;
    height: 100%;
    background-color: #0eccaa; /* Зеленая активная полоса */
    bottom: 0;
    transition: width 0.3s ease, transform 0.3s ease; /* Анимация изменения ширины и позиции */
}

.active-tab-indicator::before {
    content: '';
    position: absolute;
    height: 100%;
    background-color: #0eccaa; /* Зеленая полоса, зависимая от количества элементов */
    transform: scaleX(0); /* Начальное состояние: полоса невидима */
    transform-origin: bottom left;
    transition: transform 0.3s ease; /* Анимация изменения ширины */
}
</style>
  
